import React, { useState, useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";
import "../../assets/css/Jobs.css"; // reuse job styling for layout consistency
import { FaUserTie, FaBuilding, FaQuoteLeft } from "react-icons/fa";

const SatisfactionSurveys = () => {
  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visibleCount, setVisibleCount] = useState(4);

  useEffect(() => {
    const fetchSurveys = async () => {
      try {
        const response = await fetch("https://mysafari.safari-technologies.com/api/enquete-satisfaction");
        if (!response.ok) throw new Error("Erreur de chargement des données.");
        const data = await response.json();
        setSurveys(data);
      } catch (err) {
        console.error(err);
        setError("Impossible de charger les témoignages pour le moment.");
      } finally {
        setLoading(false);
      }
    };

    fetchSurveys();
  }, []);

  const handleShowMore = () => {
    setVisibleCount((prev) => prev + 4);
  };

  if (loading)
    return (
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
        <div className="spinner-border text-primary" role="status"></div>
        <p className="mt-3 text-primary">Chargement des témoignages...</p>
      </div>
    );

  if (error)
    return (
      <div className="text-center mt-5 text-danger">
        <p>{error}</p>
      </div>
    );

  return (
    <div>
      <Header />
      <section className="container mt-5 mb-5">
        <h1 className="text-center mb-5 mt-4">Retours de nos clients</h1>
        <div className="row">
          {surveys.slice(0, visibleCount).map((survey, index) => (
            <div className="col-md-6 mb-4" key={index}>
              <div className="card shadow-sm border-0 h-100 p-4 rounded-4">
                <div className="d-flex align-items-center mb-3">
                  <FaUserTie className="text-primary me-2" />
                  <h5 className="mb-0">
                    {survey.Prenom} {survey.Nom?.charAt(0)}.
                  </h5>
                </div>
                <p className="mb-1 text-muted">
                  <FaBuilding className="me-2" />
                  <strong>{survey.Poste}</strong> – {survey.Entreprise}
                </p>
                <blockquote className="blockquote mt-3">
                  <p className="fst-italic text-dark">
                    <FaQuoteLeft className="me-2 text-secondary" />
                    {survey.Commentaire}
                  </p>
                </blockquote>
              </div>
            </div>
          ))}
        </div>

        {visibleCount < surveys.length && (
          <div className="text-center mt-4">
            <button className="voir-btn" onClick={handleShowMore}>
              Voir Plus
            </button>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
};

export default SatisfactionSurveys;
